import script from "./HomeView.vue?vue&type=script&setup=true&name=HomeView&lang=js"
export * from "./HomeView.vue?vue&type=script&setup=true&name=HomeView&lang=js"

import "./HomeView.vue?vue&type=style&index=0&id=2b8ac512&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b8ac512"]])

export default __exports__